<template>
  <div>
    <div class="home">
      <div class="particles-bg">
        <div
          class="particle"
          v-for="(item, i) in 50"
          :key="i"
          :style="getParticleStyle()"
        ></div>
      </div>
      <div class="intro">
        <div class="intro-badge">
          <span class="badge-text">OUR VISION</span>
        </div>
        <div class="intro-title">
          让连接更简单
          <span>Making Connections Simpler</span>
        </div>
        <div class="intro-content">
          建立遍布全球的供应商网络，现有100多家代理品牌，15万种在库产品，800多万种在线产品，过亿元自营库存，3万多平米自有库房，承接BOM订单和年用量订单，提供国产品牌推荐和选型、替换、定制等FAE技术支持服务。
        </div>
        <div class="intro-stats">
          <div class="stat-item">
            <div class="stat-number">100+</div>
            <div class="stat-label">
              代理品牌<br /><span>Agent Brands</span>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-number">15万</div>
            <div class="stat-label">
              在库产品<br /><span>In-stock Products</span>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-number">800万</div>
            <div class="stat-label">
              在线产品<br /><span>Online Products</span>
            </div>
          </div>
          <div class="stat-item">
            <div class="stat-number">3万㎡</div>
            <div class="stat-label">
              自有库房<br /><span>Own Warehouse</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主营品牌和代理品牌 -->
    <div class="brands-section">
      <div class="content block">
        <div class="brands-container">
          <!-- 主营品牌 -->
          <div class="brand-card main-brand">
            <div class="brand-header">
              <div class="brand-icon">
                <i class="el-icon-star-on"></i>
              </div>
              <div class="brand-titles">
                <div class="brand-title-zh">主营品牌</div>
                <div class="brand-title-en">Main Brands</div>
              </div>
            </div>
            <div class="brand-image-wrapper">
              <img :src="mainBrandImg" alt="主营品牌" class="brand-image" />
              <div class="brand-overlay"></div>
            </div>
          </div>

          <!-- 代理品牌 -->
          <div class="brand-card agent-brand">
            <div class="brand-header">
              <div class="brand-icon">
                <i class="el-icon-connection"></i>
              </div>
              <div class="brand-titles">
                <div class="brand-title-zh">代理品牌</div>
                <div class="brand-title-en">Agent Brands</div>
              </div>
            </div>
            <div class="brand-image-wrapper">
              <img :src="agentBrandImg" alt="代理品牌" class="brand-image" />
              <div class="brand-overlay"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 我们的文化 -->
    <div class="index_field culture-section">
      <div class="content block">
        <div class="title">
          <div class="title-zh">我们的文化</div>
          <div class="title-en">Our Culture</div>
        </div>
        <div class="culture-blocks">
          <!-- 使命 -->
          <div class="culture-block mission">
            <div class="block-header">
              <i class="el-icon-aim"></i>
              <span class="block-label">使命</span>
            </div>
            <div class="block-content">
              <div class="block-title">让连接更可靠 更简单 更环保</div>
              <div class="block-desc">致力于为客户提供高品质的连接解决方案</div>
            </div>
          </div>
          <!-- 愿景 -->
          <div class="culture-block vision">
            <div class="block-header">
              <i class="el-icon-trophy"></i>
              <span class="block-label">愿景</span>
            </div>
            <div class="block-content">
              <div class="block-title">全球领先的连接器全面解决方案提供商</div>
              <div class="block-desc">成为行业标杆，引领行业发展</div>
            </div>
          </div>
          <!-- 文化 -->
          <div class="culture-block values">
            <div class="block-header">
              <i class="el-icon-star-on"></i>
              <span class="block-label">文化</span>
            </div>
            <div class="block-content">
              <div class="value-tags">
                <span class="value-tag">以客户为中心</span>
                <span class="value-tag">以奋斗者为本</span>
                <span class="value-tag">坚持学习与变革</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      mainBrandImg: require("/src/assets/主营品牌.png"), // 主营品牌图片
      agentBrandImg: require("/src/assets/代理品牌.png"), // 代理品牌图片
    };
  },
  methods: {
    getParticleStyle() {
      const random = (min, max) => Math.random() * (max - min) + min;
      const size = random(2, 6);
      const x = random(0, 100);
      const y = random(0, 100);
      const duration = random(15, 30);
      const delay = random(0, 10);
      const opacity = random(0.3, 0.8);

      return {
        left: `${x}%`,
        top: `${y}%`,
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${duration}s`,
        animationDelay: `${delay}s`,
        opacity: opacity,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.home {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 700px;
  background: linear-gradient(135deg, #0a1929 0%, #1a237e 50%, #0d47a1 100%);
  overflow: hidden;

  .particles-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;

    .particle {
      position: absolute;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.8) 0%,
        rgba(255, 255, 255, 0) 70%
      );
      border-radius: 50%;
      animation: float linear infinite;
      box-shadow: 0 0 10px rgba(100, 200, 255, 0.5);

      @keyframes float {
        0% {
          transform: translateY(0) translateX(0) scale(1);
          opacity: 0;
        }
        10% {
          opacity: 1;
        }
        90% {
          opacity: 1;
        }
        100% {
          transform: translateY(-100vh) translateX(50px) scale(1.5);
          opacity: 0;
        }
      }
    }
  }

  .home-pic {
    width: 100%;
    display: block;
  }

  .intro {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    color: white;
    width: 90%;
    max-width: 1200px;
    z-index: 2;

    .intro-badge {
      display: inline-block;
      padding: 12px 30px;
      background: rgba(255, 255, 255, 0.15);
      backdrop-filter: blur(10px);
      border-radius: 50px;
      border: 1px solid rgba(255, 255, 255, 0.3);
      margin-bottom: 40px;
      animation: fadeInDown 1s ease-out;

      .badge-text {
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 3px;
        text-transform: uppercase;
        color: #fff;
      }
    }

    .intro-title {
      font-size: 56px;
      font-weight: 700;
      line-height: 1.2;
      margin-bottom: 20px;
      animation: fadeInUp 1s ease-out 0.2s both;
      color: #fff;

      span {
        display: block;
        font-size: 32px;
        font-weight: 300;
        margin-top: 15px;
        letter-spacing: 2px;
        color: rgba(255, 255, 255, 0.9);
      }
    }

    .intro-content {
      font-size: 18px;
      line-height: 1.8;
      color: rgba(255, 255, 255, 0.95);
      max-width: 900px;
      margin: 0 auto 30px;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
      animation: fadeInUp 1s ease-out 0.4s both;
    }

    .intro-stats {
      display: flex;
      justify-content: center;
      gap: 60px;
      margin-top: 50px;
      animation: fadeInUp 1s ease-out 0.6s both;

      .stat-item {
        text-align: center;
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-10px);
        }

        .stat-number {
          font-size: 48px;
          font-weight: 700;
          color: #fff;
          line-height: 1;
          margin-bottom: 10px;
          text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
        }

        .stat-label {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
          letter-spacing: 1px;
          line-height: 1.6;

          span {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.6);
            display: block;
            margin-top: 5px;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
        }
      }
    }
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .home {
    min-height: 600px;

    .intro {
      .intro-title {
        font-size: 36px;

        span {
          font-size: 20px;
        }
      }

      .intro-content {
        font-size: 16px;
      }

      .intro-stats {
        gap: 30px;
        flex-wrap: wrap;

        .stat-item {
          .stat-number {
            font-size: 32px;
          }
        }
      }
    }
  }
}

.brands-section {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  padding: 80px 0;

  .brands-container {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-top: 50px;
    flex-wrap: wrap;
    padding: 0 40px;
  }

  .brand-card {
    flex: 1;
    min-width: 450px;
    max-width: 600px;
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 8px 40px rgba(0, 0, 0, 0.08);
    transition: all 0.4s ease;
    position: relative;

    &:hover {
      transform: translateY(-15px);
      box-shadow: 0 20px 60px rgba(0, 112, 192, 0.15);

      .brand-image {
        transform: scale(1.05);
      }

      .brand-overlay {
        opacity: 0.3;
      }

      .brand-icon i {
        transform: rotate(360deg) scale(1.2);
      }
    }

    .brand-header {
      display: flex;
      align-items: center;
      padding: 30px 35px;
      background: linear-gradient(135deg, #ffffff 0%, #f0f7ff 100%);
      border-bottom: 3px solid;

      .brand-icon {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 20px;
        transition: all 0.4s ease;

        i {
          font-size: 32px;
          color: #fff;
          transition: all 0.6s ease;
        }
      }

      .brand-titles {
        flex: 1;

        .brand-title-zh {
          font-size: 28px;
          font-weight: 700;
          color: #222;
          margin-bottom: 5px;
        }

        .brand-title-en {
          font-size: 14px;
          color: #999;
          letter-spacing: 2px;
          text-transform: uppercase;
        }
      }
    }

    &.main-brand {
      .brand-header {
        border-bottom-color: #0070c0;
      }

      .brand-icon {
        background: linear-gradient(135deg, #0070c0 0%, #00a0e9 100%);
      }
    }

    &.agent-brand {
      .brand-header {
        border-bottom-color: #52c41a;
      }

      .brand-icon {
        background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
      }
    }

    .brand-image-wrapper {
      position: relative;
      width: 100%;
      overflow: hidden;

      .brand-image {
        width: 100%;
        height: auto;
        display: block;
        transition: all 0.4s ease;
      }

      .brand-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          180deg,
          rgba(0, 112, 192, 0) 0%,
          rgba(0, 112, 192, 0.2) 100%
        );
        opacity: 0;
        transition: all 0.4s ease;
        pointer-events: none;
      }
    }
  }
}

@media (max-width: 1200px) {
  .brands-section {
    .brand-card {
      min-width: 100%;
      max-width: 100%;
    }
  }
}

.culture-section {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  padding-bottom: 100px;
}

.culture-blocks {
  display: flex;
  justify-content: center;
  gap: 40px;
  margin-top: 60px;
  flex-wrap: wrap;
  padding: 0 40px;
}

.culture-block {
  flex: 1;
  min-width: 320px;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  padding: 50px 40px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
  }

  &.mission::before {
    background: linear-gradient(90deg, #0070c0, #00a0e9);
  }

  &.vision::before {
    background: linear-gradient(90deg, #52c41a, #73d13d);
  }

  &.values::before {
    background: linear-gradient(90deg, #fa8c16, #ffc53d);
  }

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 12px 40px rgba(0, 112, 192, 0.12);
  }

  .block-header {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    i {
      font-size: 32px;
      margin-right: 12px;
    }

    .block-label {
      font-size: 16px;
      font-weight: 600;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 2px;
    }
  }

  &.mission .block-header i {
    color: #0070c0;
  }

  &.vision .block-header i {
    color: #52c41a;
  }

  &.values .block-header i {
    color: #fa8c16;
  }

  .block-content {
    .block-title {
      font-size: 24px;
      font-weight: 600;
      color: #222;
      line-height: 1.6;
      margin-bottom: 15px;
    }

    .block-desc {
      font-size: 15px;
      color: #888;
      line-height: 1.8;
    }
  }

  .value-tags {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .value-tag {
      display: inline-block;
      padding: 14px 24px;
      background: linear-gradient(135deg, #fff7e6 0%, #ffe7ba 100%);
      border-radius: 8px;
      font-size: 17px;
      font-weight: 600;
      color: #d46b08;
      text-align: center;
      transition: all 0.3s ease;

      &:hover {
        background: linear-gradient(135deg, #ffd591 0%, #ffbb96 100%);
        color: #ad4e00;
      }
    }
  }
}

.index_field {
  background: #fdfdfd;
}
</style>
